import React from 'react'
import './style/bottom.css'
import logo from '../../assets/Logo.png'
import { NavLink } from 'react-router-dom'
export default function Footer() {
  return (
    <div className="footer">
      <div className="foot_body">
        <div className="footer_left">
          <img src={logo} alt="" />
          <ul>
            <NavLink to={''}>
              <li
                onClick={() => {
                  //跳转时页面回到顶部
                  window.scrollTo(0, 0)
                }}>
                首页
              </li>
            </NavLink>
            <NavLink to={'/statement'}>
              <li>免责声明</li>
            </NavLink>
            <NavLink to={'/complaint'}>
              <li>投诉处理</li>
            </NavLink>
            <NavLink to={'/about'}>
              <li>关于我们</li>
            </NavLink>
          </ul>
        </div>
        <div className="footer_right">
          Copyright © 2018 上海载盟信息技术有限公司 沪ICP备18021813号-9
        </div>
      </div>
    </div>
  )
}
